export default __webpack_public_path__ + "static/media/boBackground.ea78a4a6.png";